webpackJsonp([149911758248304],{

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Actions = __webpack_require__(44);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Actions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Extracting Actions'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The CLI provides a way to extract the auto-generated actions so that you can see the code, as well as modify its behavior.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can learn more about that command ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/cli/lore-extract-action/' },
	        'here'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-actions-extract-js-7576cc742c3ce11d0776.js